import Vue from "vue";

import { build } from "../lib/masks";

const resolve = (path, obj) => {
  if (!path) return;
  return path.split(".").reduce(function(prev, curr) {
    return prev ? prev[curr] : null;
  }, obj || self);
};

const maskValue = (el, binding, vnode) => {
  const expr = vnode.data.model.expression.split(".");
  const field = expr.pop();
  let obj = vnode.context;
  if (expr.length > 0) {
    obj = resolve(expr.join("."), vnode.context);
  }
  try {
    const val = build[binding.value](vnode.data.model.value);
    vnode.context.$nextTick(() => {
      vnode.context.$set(obj, field, val);
      el.querySelector("input").value = build[binding.value](
        vnode.data.model.value
      );
    });
  } catch (err) {
    console.error("máscara " + binding.value + " existe?");
    console.log(err);
  }
};

const elementEvent = (el, binding, vnode) => {
  vnode.context.$nextTick(() => {
    const expr = vnode.data.model.expression.split(".");
    const field = expr.pop();
    let obj = vnode.context;
    if (expr.length > 0) {
      obj = resolve(expr.join("."), vnode.context);
    }
    el.value = build[binding.value](obj[field]);
    setTimeout(() => {
      el.setSelectionRange(el.value.length, el.value.length);
    }, 50);
  });
};

Vue.directive("mask", {
  bind(el, binding, vnode) {
    maskValue(el, binding, vnode);
    const input = el.querySelector("input");
    input.addEventListener("blur", () => {
      elementEvent(input, binding, vnode);
    });
    input.addEventListener("focus", () => {
      elementEvent(input, binding, vnode);
    });
  },
  componentUpdated: maskValue,
});
